import React, { PropsWithChildren } from 'react';
import { ClientWebRouteParams, ClientWebRouteParamsContext } from '@cp/entities/clientWebRoutes';

export const CurrentRouteParamsProvider = (props: PropsWithChildren & { routerContextValue: ClientWebRouteParams }) => {
  return <ClientWebRouteParamsContext.Provider value={props.routerContextValue}>{props.children}</ClientWebRouteParamsContext.Provider>;
};
